import { useContext } from 'react';

import { AntMessageContext } from '../contexts/ant-message-context';

export function useAntMessage() {
    return useContext(AntMessageContext);
}
